import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DescriptionIcon from "@mui/icons-material/Description";
import React from "react";

import { styles } from "./NoProposalView.styles";

export type INoProposalViewProps = {
  title: string;
  description: string;
  showButton?: boolean;
  buttonTitle?: string;
  buttonVariant?: "text" | "outlined" | "contained";
  buttonSize?: "small" | "medium" | "large";
  buttonAction?(): void;
};

export const NoProposalView: React.FC<INoProposalViewProps> = ({
  title,
  description,
  showButton,
  buttonSize,
  buttonTitle,
  buttonVariant,
  buttonAction
}) => {
  return (
    <Box sx={styles.centered}>
      <DescriptionIcon sx={styles.documentationIcon} aria-hidden={true} />
      {title && (
        <Typography component="h1" sx={styles.heading} data-test="no-proposals-heading">
          {title}
        </Typography>
      )}
      <Typography component="p" sx={styles.description}>
        {description}
      </Typography>
      {showButton && (
        <Button
          size={buttonSize ?? "small"}
          variant={buttonVariant ?? "outlined"}
          data-test="add-proposals-content-button"
          onClick={buttonAction}
        >
          {buttonTitle}
        </Button>
      )}
    </Box>
  );
};
